<script>
    export let gotoHome = () => {};
</script>

<h1>About this site</h1>
<div>
    Created by <a href="https://szabgab.com/">Gabor Szabo</a> as an experiment to use <a href="https://svelte.dev/">Svelte</a> and to play with words.
    The source code is available <a href="https://github.com/szabgab/biervos">here</a>.
</div>

<div>
    <hr>
    <button on:click={gotoHome}>Home</button>
</div>
